/** Preset table shapes matching floor-plan SVG icons (shape + seats). */
/** Normalized canvas footprint aligned to 150px floor artwork. */
export const FLOOR_TABLE_CANVAS_UNITS = 150;
export const TABLE_TEMPLATES = [
    { id: "square_2", shape: "square", seats: 2, label: "Square · 2 seats", defaultW: FLOOR_TABLE_CANVAS_UNITS, defaultH: FLOOR_TABLE_CANVAS_UNITS },
    { id: "square_4", shape: "square", seats: 4, label: "Square · 4 seats", defaultW: FLOOR_TABLE_CANVAS_UNITS, defaultH: FLOOR_TABLE_CANVAS_UNITS },
    { id: "rect_6", shape: "rect", seats: 6, label: "Rectangle · 6 seats", defaultW: FLOOR_TABLE_CANVAS_UNITS, defaultH: FLOOR_TABLE_CANVAS_UNITS },
    { id: "rect_8", shape: "rect", seats: 8, label: "Rectangle · 8 seats", defaultW: FLOOR_TABLE_CANVAS_UNITS, defaultH: FLOOR_TABLE_CANVAS_UNITS },
    { id: "circle_2", shape: "circle", seats: 2, label: "Round · 2 seats", defaultW: FLOOR_TABLE_CANVAS_UNITS, defaultH: FLOOR_TABLE_CANVAS_UNITS },
    { id: "circle_4", shape: "circle", seats: 4, label: "Round · 4 seats", defaultW: FLOOR_TABLE_CANVAS_UNITS, defaultH: FLOOR_TABLE_CANVAS_UNITS },
    { id: "circle_6", shape: "circle", seats: 6, label: "Round · 6 seats", defaultW: FLOOR_TABLE_CANVAS_UNITS, defaultH: FLOOR_TABLE_CANVAS_UNITS },
    { id: "circle_8", shape: "circle", seats: 8, label: "Round · 8 seats", defaultW: FLOOR_TABLE_CANVAS_UNITS, defaultH: FLOOR_TABLE_CANVAS_UNITS },
];
const TEMPLATE_BY_ID = Object.fromEntries(TABLE_TEMPLATES.map((t) => [t.id, t]));
export function resolveTableTemplateId(table) {
    if (table.table_template_id && TEMPLATE_BY_ID[table.table_template_id]) {
        return table.table_template_id;
    }
    return templateIdFromTable(table);
}
export function templateIdFromTable(table) {
    const shape = table.shape || "square";
    const seats = table.seats && table.seats > 0 ? table.seats : 4;
    const exact = `${shape}_${seats}`;
    if (TEMPLATE_BY_ID[exact])
        return exact;
    if (shape === "circle") {
        if (seats <= 2)
            return "circle_2";
        if (seats <= 4)
            return "circle_4";
        if (seats <= 6)
            return "circle_6";
        return "circle_8";
    }
    if (shape === "rect") {
        return seats <= 6 ? "rect_6" : "rect_8";
    }
    return seats <= 2 ? "square_2" : "square_4";
}
export function resolveTableTemplate(table) {
    return TEMPLATE_BY_ID[resolveTableTemplateId(table)];
}
/** Apply floor graphic + shape only; does not change `seats`. */
export function applyTableTemplate(table, templateId) {
    const template = TEMPLATE_BY_ID[templateId];
    if (!template)
        return table;
    const next = {
        ...table,
        shape: template.shape,
        table_template_id: templateId,
    };
    const layout = table.layout;
    if (layout) {
        next.layout = {
            ...layout,
            w: template.defaultW,
            h: template.defaultH,
        };
    }
    return next;
}
export function clearTableTemplateOverride(table) {
    const next = { ...table };
    delete next.table_template_id;
    return next;
}
//# sourceMappingURL=table_templates.js.map